// import React, { useEffect, useState } from "react";
// import "./Nominee.scss";
// import { TitleBar } from "../../../Global/TitleBar/TitleBar";
// import { TopBar } from "../../TopBar/TopBar";
// import { IoSearchSharp } from "react-icons/io5";
// import { GreyBackgroundButton, GreyBorderButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../Global/GlobalButton";
// import { LuFilter } from "react-icons/lu";
// import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
// import { MdEditSquare } from "react-icons/md";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { EXCHNAGE_URL } from "../../../../Url/Url";
// import { toast } from "react-toastify";
// import { GlobalSecondTable } from "../../../Global/GlobalSecondTable/GlobalSecondTable";
// import { Modal } from "react-bootstrap";
// import { InputLabel, InputType } from "../../../Global/GlobalFormElement";
// import { SubHeading } from "../../../Global/GlobalText";
// import * as XLSX from "xlsx";
// import { useLoading } from "../../../LoadingContext"; // ✅ ADD THIS

// export const Nominee = () => {
//     const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

//   const [show, setShow] = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [selectedRowsData, setSelectedRowsData] = useState([]);
//   const [nomineeData, setNomineeData] = useState(null);
//   const [loader, setLoader] = useState(false);
//   const [columns, setColumns] = useState([]);
//   const [data, setData] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [createdBy, setCreatedBy] = useState()
//   const [role, setRole] = useState("")
//   const [formValues, setFormValues] = useState({});
//   const [registrationFormId, setRegistrationFormId] = useState()
//   const [singleSelectedNomineeData, setSinlgeSelectedNomineeData] = useState(null);


//   const eventIdGet = useSelector((state) => state?.users?.id);
//   const eventId = String(eventIdGet)
//   const token = localStorage.getItem("token")

//   const handleCheckboxChange = (rowId, isChecked) => {
//     const rowData = data.find(row => row.rowId === rowId);
  
//     if (!rowData) {
//       console.error("Row data not found for rowId:", rowId);
//       return;
//     }
//     setSelectedRows((prevSelected) =>
//       isChecked ? [...prevSelected, rowId] : prevSelected.filter(id => id !== rowId)
//     );
  
//     setSelectedRowsData((prevData) =>
//       isChecked
//         ? [...prevData, rowData]
//         : prevData.filter(row => row.rowId !== rowId)
//     );
  
//     console.log("Updated Selected Rows Data:", selectedRowsData);
//   };
//   const handleRowClick = (row) => {
//     console.log("Row clicked:", row);
//   };


//   console.log(selectedRowsData,"rowsdasdasd")

//   const getNomineeData = async () => {
//           setLoading(true); // ✅ Start global loader

//     try {
//       const apiUrl = `${EXCHNAGE_URL}/registrationData?eventId=${eventId}`;
//       const response = await axios.get(apiUrl, {
//         headers: {
//           "Content-Type": "Application/json",
//           authorization: `Bearer ${token}`,
//         },
//       });
//       if (response.status === 200) {
//         const subData = response.data.data
//         setNomineeData(subData)
//       }
//     } catch (error) {
//       console.log(error)
//     }finally {
//       setLoader(false);
//       setLoading(false); // ✅ Stop global loader
//     }
//   }

//   useEffect(() => {
//     getNomineeData();
//   }, [eventId]);
//   useEffect(() => {
//     if (nomineeData && nomineeData.formSchema && nomineeData.registrationData) {
//       // Mapping column headers
//       const columnsMapped = nomineeData.formSchema.map((field) => ({
//         label: field.label,
//         accessor: field.field_name,
//       }));

//       // Adding extra columns
//       columnsMapped.push({ label: "Created Date", accessor: "created_at" });
//       columnsMapped.push({ label: "Modification Date", accessor: "updated_at" });

//       setColumns(columnsMapped);

//       // Mapping row data
//       const dataMapped = nomineeData.registrationData.map((submission, index) => {
//         const row = {
//           rowId: `${index}-${submission.created_by}-${submission.role}`, // Unique row ID
//           created_by: submission.created_by, // Storing created_by
//           role: submission.role, // Storing role
//         };

//         // Mapping form fields
//         nomineeData.formSchema.forEach((field) => {
//           const fieldData = submission.fields.find((item) => item[field.field_name] !== undefined);
//           row[field.field_name] = fieldData ? fieldData[field.field_name] : "";
//         });

//         row["created_at"] = new Date(submission.created_at).toLocaleDateString("en-GB");
//         row["updated_at"] = (
//           <div
//             style={{ gap: "1rem", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
//             onClick={() => handleEditClick(row)}
//           >
//             {new Date(submission.updated_at).toLocaleDateString("en-GB")}
//             <MdEditSquare />
//           </div>
//         );

//         return row;
//       });

//       setData(dataMapped);
//     }
//   }, [nomineeData]);


//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues((prevValues) => ({
//       ...prevValues,
//       [name]: value,
//     }));
//   };

//   const singleNomineeData = async (eventId, createdBy, role) => {
//     setLoader(true);
//         setLoading(true); // ✅ Start global loader

//     try {
//       const apiUrl = `${EXCHNAGE_URL}/registrationDataById?eventId=${eventId}&created_by=${createdBy}&role=${role}`;
//       const response = await axios.get(apiUrl, {
//         headers: {
//           "Content-Type": "Application/json",
//           authorization: `Bearer ${token}`,
//         },
//       });

//       console.log("API Response Data:", response.data);

//       if (response.status === 200) {
//         const responseData = response.data.data;

//         if (!responseData?.fetchfields?.fields) {
//           console.error("Error: fetchfields or fields is missing in API response", responseData);
//           return;
//         }

//         setSinlgeSelectedNomineeData(responseData.fetchfields);
//         setRegistrationFormId(responseData.fetchfields.registrationFormId);
//         setShow(true);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoader(false);
//       setLoading(false); // ✅ Stop global loader
//     }
//   };


//   const handleExportCsv = async () => {
//     if (selectedRowsData.length === 0) {
//       toast.error("No rows selected for export!");
//       return;
//     }

//     setLoading(true); // ✅ Start global loader
//     try {
//       const worksheet = XLSX.utils.json_to_sheet(selectedRowsData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "NomineeData");
//       XLSX.writeFile(workbook, "NomineeData.xlsx");
  
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Failed to export CSV");
//     } finally {
//       setLoading(false); // ✅ Stop global loader
//     }
//   };


//   const handleClose = () => {
//     setShow(false);
//     setSelectedRow(null);
//   }

//   const handleEditClick = (row) => {
//     console.log("Editing row:", row);
//     setCreatedBy(row.created_by)
//     setRole(row.role)
//     setFormValues(row);
//     setShow(true);
//     singleNomineeData(eventId, row.created_by, row.role);

//   };

//   const handleUpdateNominee = async (e) => {
//     e.preventDefault();

//     console.log("singleSelectedNomineeData:", singleSelectedNomineeData);

//     if (!singleSelectedNomineeData?.fields || !Array.isArray(singleSelectedNomineeData.fields)) {
//       console.error("Error: singleSelectedNomineeData or fields is undefined.");
//       return;
//     }
//     setLoading(true); // ✅ Start global loader

//     const updates = Object.keys(formValues).map((key) => {
//       const fieldData = singleSelectedNomineeData.fields.find((item) => item[key] !== undefined);

//       return fieldData
//         ? {
//           registrationDataId: fieldData.registrationDataId,
//           field_name: key,
//           field_value: formValues[key]
//         }
//         : null;
//     }).filter(Boolean);

//     const payload = {
//       eventId: eventId,
//       registrationFormId: registrationFormId,
//       created_by: createdBy,
//       role: role,
//       updates
//     };

//     try {
//       const apiUrl = `${EXCHNAGE_URL}/registrationDataEdit`;
//       const response = await axios.put(apiUrl, payload, {
//         headers: {
//           "Content-Type": "Application/json",
//           authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.status === 200) {
//         toast.success("Nominee data updated successfully!");
//         setData((prevData) =>
//           prevData.map((row) =>
//             row.rowId === registrationFormId
//               ? {
//                 ...row,
//                 updated_at: new Date().toLocaleDateString("en-GB") // Update modification date
//               }
//               : row
//           )
//         );

//         getNomineeData();
//         handleClose();
//       }
//     } catch (error) {
//       console.error("Error updating nominee data:", error);
//     }finally {
//       setLoading(false); // ✅ Stop global loader
//     }
//   };




//   return (
//     <div>
//       <div className="nominee_data_div">
//         <TitleBar title="Nominee Listing" />
//         <div className="nominee_white_bg">
//           <TopBar titleheading="Nominee Listing" />

//           <div className="nominee_table_div">
//             <div className="nominee_table_search">
//               <div className="nominee_table_icon">
//                 <IoSearchSharp />
//               </div>
//               <div className="nominee_table_icon_content">
//                 <input type="text" placeholder="Search here..." />
//               </div>
//             </div>

//             <div className="nominee_filter_btn">
//               <ViewMoreButton style={{ color: "#333333" }}
//                 onClick={handleExportCsv}
//               >
//                 Export CSV
//               </ViewMoreButton>

//               <ViewMoreButton
//                 style={{ color: "#333333" }}
//                 onClick={() => window.location.reload()}

//               >
//                 Refresh
//               </ViewMoreButton>


//               <GreyfilterButton className="nominee_filter_icon">
//                 <LuFilter />
//                 Filter
//               </GreyfilterButton>


//             </div>
//           </div>
//         </div>

//         <GlobalSecondTable className="hide-select-column"
//           data={data}
//           columns={columns}
//           selectedRows={selectedRows || []}  // Ensure selectedRows is always an array
//           onCheckboxChange={handleCheckboxChange}
//           onRowClick={handleRowClick}
//           disableSelection={false}
//         />


//       </div>

//       <Modal show={show} onHide={handleClose} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Nominee Data</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="juryassign_cont">

//             <div className="juryassign_heading">
//               <SubHeading>Edit Nominee </SubHeading>
//             </div>
//             <form onSubmit={(e) => e.preventDefault()} className="juryassign_form">
//               {columns
//                 .filter(
//                   (column) =>
//                     column.label !== "Modification Date" && column.label !== "Created Date"

//                 )
//                 .map((column, index) => (
//                   <div key={index} className="juryassign_row">
//                     <InputLabel>{column.label}</InputLabel>
//                     <InputType
//                       type="text"
//                       name={column.accessor}
//                       value={formValues[column.accessor] || ""}
//                       onChange={handleInputChange}
//                       placeholder={`Enter ${column.label}`}
//                       disabled={column.accessor.startsWith("label")}
//                     />
//                   </div>
//                 ))}

//               <div className="juryassign_btn">
//                 <RedBackgroundButton type="submit" onClick={handleUpdateNominee}>Update</RedBackgroundButton>
//                 <GreyBackgroundButton type="button" onClick={handleClose} style={{ marginLeft: "10px" }}>
//                   Close
//                 </GreyBackgroundButton>
//               </div>
//             </form>
//           </div>

//         </Modal.Body>
//       </Modal>


//     </div>
//   );
// };


import React, { useEffect, useState } from "react";
import "./Nominee.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import { IoSearchSharp } from "react-icons/io5";
import { GreyBackgroundButton, GreyBorderButton, GreyfilterButton, RedBackgroundButton, ViewMoreButton } from "../../../Global/GlobalButton";
import { LuFilter } from "react-icons/lu";
import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
import { MdEditSquare } from "react-icons/md";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { GlobalSecondTable } from "../../../Global/GlobalSecondTable/GlobalSecondTable";
import { Modal } from "react-bootstrap";
import { InputLabel, InputType } from "../../../Global/GlobalFormElement";
import { SubHeading } from "../../../Global/GlobalText";
import * as XLSX from "xlsx";
import { useLoading } from "../../../LoadingContext";

export const Nominee = () => {
  const { setLoading } = useLoading();

  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowsData, setSelectedRowsData] = useState([]); 
  const [nomineeData, setNomineeData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [createdBy, setCreatedBy] = useState()
  const [role, setRole] = useState("")
  const [formValues, setFormValues] = useState({});
  const [registrationFormId, setRegistrationFormId] = useState()
  const [singleSelectedNomineeData, setSinlgeSelectedNomineeData] = useState(null);

  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet)
  const token = localStorage.getItem("token")

  const handleCheckboxChange = (rowId, isChecked) => {
    const rowData = data.find(row => row.rowId === rowId);
  
    if (!rowData) {
      console.error("Row data not found for rowId:", rowId);
      return;
    }
    setSelectedRows((prevSelected) =>
      isChecked ? [...prevSelected, rowId] : prevSelected.filter(id => id !== rowId)
    );
  
    setSelectedRowsData((prevData) => 
      isChecked 
        ? [...prevData, rowData] 
        : prevData.filter(row => row.rowId !== rowId)
    );
  };

  // ✅ Select All Rows
  const handleSelectAll = () => {
    const allRowIds = data.map(row => row.rowId);
    setSelectedRows(allRowIds);
    setSelectedRowsData([...data]);
    toast.success(`Selected ${data.length} rows`);
  };

  // ✅ Deselect All Rows
  const handleDeselectAll = () => {
    setSelectedRows([]);
    setSelectedRowsData([]);
    toast.info("All rows deselected");
  };

  const handleRowClick = (row) => {
    console.log("Row clicked:", row);
  };

  const getNomineeData = async () => {
    setLoading(true);
    try {
      const apiUrl = `${EXCHNAGE_URL}/registrationData?eventId=${eventId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const subData = response.data.data
        setNomineeData(subData)
      }
    } catch (error) {
      console.log(error)
      toast.error("Failed to fetch nominee data")
    } finally {
      setLoader(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    getNomineeData();
  }, [eventId]);

  useEffect(() => {
    if (nomineeData && nomineeData.formSchema && nomineeData.registrationData) {
      // ✅ Mapping column headers with proper labels
      const columnsMapped = nomineeData.formSchema.map((field) => ({
        label: field.label,
        accessor: field.field_name,
      }));

      // Adding extra columns with proper headers
      columnsMapped.push({ label: "Created Date", accessor: "created_at" });
      columnsMapped.push({ label: "Modification Date", accessor: "updated_at" });

      setColumns(columnsMapped);

      const dataMapped = nomineeData.registrationData.map((submission, index) => {
        const row = {
          rowId: `${index}-${submission.created_by}-${submission.role}`,
          created_by: submission.created_by,
          role: submission.role,
        };

        nomineeData.formSchema.forEach((field) => {
          const fieldData = submission.fields.find((item) => item[field.field_name] !== undefined);
          row[field.field_name] = fieldData ? fieldData[field.field_name] : "";
        });

        row["created_at"] = new Date(submission.created_at).toLocaleDateString("en-GB");
        row["updated_at"] = (
          <div
            style={{ gap: "1rem", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
            onClick={() => handleEditClick(row)}
          >
            {new Date(submission.updated_at).toLocaleDateString("en-GB")}
            <MdEditSquare />
          </div>
        );

        return row;
      });

      setData(dataMapped);
    }
  }, [nomineeData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const singleNomineeData = async (eventId, createdBy, role) => {
    setLoader(true);
    setLoading(true);

    try {
      const apiUrl = `${EXCHNAGE_URL}/registrationDataById?eventId=${eventId}&created_by=${createdBy}&role=${role}`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });

      console.log("API Response Data:", response.data);

      if (response.status === 200) {
        const responseData = response.data.data;

        if (!responseData?.fetchfields?.fields) {
          console.error("Error: fetchfields or fields is missing in API response", responseData);
          return;
        }

        setSinlgeSelectedNomineeData(responseData.fetchfields);
        setRegistrationFormId(responseData.fetchfields.registrationFormId);
        setShow(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch nominee data");
    } finally {
      setLoader(false);
      setLoading(false);
    }
  };

  // ✅ Improved Export CSV
// ✅ Improved Export CSV with proper labels from formSchema
const handleExportCsv = () => {
  if (selectedRowsData.length === 0) {
    toast.error("No rows selected for export! Please select at least one row.");
    return;
  }

  setLoading(true);
  try {
    // Create a mapping of field_name to label from formSchema
    const fieldLabelMap = {};
    if (nomineeData && nomineeData.formSchema) {
      nomineeData.formSchema.forEach((field) => {
        fieldLabelMap[field.field_name] = field.label;
      });
    }

    // Prepare data for export - use labels as headers
    const exportData = selectedRowsData.map(row => {
      const cleanRow = {};
      Object.keys(row).forEach(key => {
        // Skip internal keys
        if (key === 'rowId' || key === 'created_by' || key === 'role') return;
        
        // Get the label from the map, or use the key if not found
        const headerLabel = fieldLabelMap[key] || key;
        
        // Handle React elements (like the edit button in updated_at)
        if (typeof row[key] === 'object' && row[key]?.type) {
          // Extract text content from React element
          if (key === 'updated_at' && row[key]?.props?.children) {
            // Get the date string from the updated_at column
            const dateStr = row[key].props.children[0];
            cleanRow[headerLabel] = dateStr || '';
          } else {
            cleanRow[headerLabel] = '';
          }
        } else {
          cleanRow[headerLabel] = row[key] || '';
        }
      });
      return cleanRow;
    });

    // Create worksheet with proper headers (labels)
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    
    // Auto-size columns
    const colWidths = [];
    Object.keys(exportData[0] || {}).forEach((key) => {
      let maxLength = key.length;
      exportData.forEach(row => {
        const value = String(row[key] || '');
        maxLength = Math.max(maxLength, value.length);
      });
      colWidths.push({ wch: Math.min(maxLength + 5, 50) });
    });
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "NomineeData");
    XLSX.writeFile(workbook, `NomineeData_${new Date().toISOString().slice(0,10)}.xlsx`);

    toast.success(`Exported ${exportData.length} rows successfully!`);
  } catch (error) {
    console.error("Error exporting CSV:", error);
    toast.error("Failed to export CSV");
  } finally {
    setLoading(false);
  }
};

  const handleClose = () => {
    setShow(false);
    setSelectedRow(null);
  }

  const handleEditClick = (row) => {
    console.log("Editing row:", row);
    setCreatedBy(row.created_by)
    setRole(row.role)
    setFormValues(row);
    setShow(true);
    singleNomineeData(eventId, row.created_by, row.role);
  };

  const handleUpdateNominee = async (e) => {
    e.preventDefault();

    console.log("singleSelectedNomineeData:", singleSelectedNomineeData);

    if (!singleSelectedNomineeData?.fields || !Array.isArray(singleSelectedNomineeData.fields)) {
      console.error("Error: singleSelectedNomineeData or fields is undefined.");
      return;
    }
    setLoading(true);

    const updates = Object.keys(formValues).map((key) => {
      const fieldData = singleSelectedNomineeData.fields.find((item) => item[key] !== undefined);

      return fieldData
        ? {
          registrationDataId: fieldData.registrationDataId,
          field_name: key,
          field_value: formValues[key]
        }
        : null;
    }).filter(Boolean);

    const payload = {
      eventId: eventId,
      registrationFormId: registrationFormId,
      created_by: createdBy,
      role: role,
      updates
    };

    try {
      const apiUrl = `${EXCHNAGE_URL}/registrationDataEdit`;
      const response = await axios.put(apiUrl, payload, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Nominee data updated successfully!");
        setData((prevData) =>
          prevData.map((row) =>
            row.rowId === registrationFormId
              ? {
                ...row,
                updated_at: new Date().toLocaleDateString("en-GB")
              }
              : row
          )
        );

        getNomineeData();
        handleClose();
      }
    } catch (error) {
      console.error("Error updating nominee data:", error);
      toast.error("Failed to update nominee data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="nominee_data_div">
        <TitleBar title="Nominee Listing" />
        <div className="nominee_white_bg">
          <TopBar titleheading="Nominee Listing" />

          <div className="nominee_table_div">
            <div className="nominee_table_search">
              <div className="nominee_table_icon">
                <IoSearchSharp />
              </div>
              <div className="nominee_table_icon_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>

            <div className="nominee_filter_btn">
              {/* ✅ Select All Button */}
              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleSelectAll}
              >
                Select All
              </ViewMoreButton>

              {/* ✅ Deselect All Button */}
              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleDeselectAll}
              >
                Deselect All
              </ViewMoreButton>

              {/* ✅ Export CSV Button */}
              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleExportCsv}
                disabled={selectedRowsData.length === 0}
              >
                Export CSV ({selectedRowsData.length})
              </ViewMoreButton>

              <ViewMoreButton
                style={{ color: "#333333" }}
                onClick={() => window.location.reload()}
              >
                Refresh
              </ViewMoreButton>

              <GreyfilterButton className="nominee_filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>
          </div>
        </div>

        <GlobalSecondTable className="hide-select-column"
          data={data}
          columns={columns}
          selectedRows={selectedRows || []}
          onCheckboxChange={handleCheckboxChange}
          onRowClick={handleRowClick}
          disableSelection={false}
        />
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Nominee Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="juryassign_cont">
            <div className="juryassign_heading">
              <SubHeading>Edit Nominee </SubHeading>
            </div>
            <form onSubmit={(e) => e.preventDefault()} className="juryassign_form">
              {columns
                .filter(
                  (column) =>
                    column.label !== "Modification Date" && column.label !== "Created Date"
                )
                .map((column, index) => (
                  <div key={index} className="juryassign_row">
                    <InputLabel>{column.label}</InputLabel>
                    <InputType
                      type="text"
                      name={column.accessor}
                      value={formValues[column.accessor] || ""}
                      onChange={handleInputChange}
                      placeholder={`Enter ${column.label}`}
                      disabled={column.accessor.startsWith("label")}
                    />
                  </div>
                ))}

              <div className="juryassign_btn">
                <RedBackgroundButton type="submit" onClick={handleUpdateNominee}>Update</RedBackgroundButton>
                <GreyBackgroundButton type="button" onClick={handleClose} style={{ marginLeft: "10px" }}>
                  Close
                </GreyBackgroundButton>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};